"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const PlayStart = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 25 25"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M18.0455 11.6849C18.6515 12.0471 18.6515 12.9528 18.0455 13.3151L9.86364 18.2058C9.25758 18.5681 8.5 18.1153 8.5 17.3907L8.5 7.60928C8.5 6.88473 9.25758 6.43189 9.86364 6.79416L18.0455 11.6849Z",
  className: "fill"
}));
var _default = exports.default = PlayStart;